import IframeEmbed from './IframeEmbed.component';
export default IframeEmbed;